export const environment = {
  production: true,
  lien: {
    baseUrl: 'https://officiel.garagedemontplaisir-maubeuge.com/',
    accueil: '',
    vsp_accueil: 'voiture-sans-permis/vsp',
    vsp_vente: 'voiture-sans-permis/vente',
    api: {
      baseUrl: 'https://api.garagedemontplaisir-maubeuge.com/',
      mail: 'sendemail',
      voitures: 'voiture'
    }
  }
};
